import { createContext } from 'react'
import { PushNotification } from 'types/pushNotifications'

const notificationContext = createContext<PushNotification | undefined>(undefined)

export default notificationContext
